import { render, staticRenderFns } from "./iusersList.vue?vue&type=template&id=2f6a5e4f&"
import script from "./iusersList.vue?vue&type=script&lang=js&"
export * from "./iusersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports